"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisementUtils = void 0;
const Utils_1 = require("./Utils");
class AdvertisementUtils {
    static isCI() {
        if (!this.isNodeEnvironment()) {
            return false;
        }
        return this.ciEnvVars.some((envVar) => {
            const value = process.env[envVar];
            return value !== undefined && value !== '' && value !== '0' && value !== 'false';
        });
    }
    static shouldShowAdvertisement() {
        var _a;
        if (!this.isNodeEnvironment()) {
            return false;
        }
        if (this.isCI()) {
            return false;
        }
        if (!process.stdout.isTTY) {
            return false;
        }
        const data = this.readConfig();
        const now = Date.now();
        if (data.adFirstDisplayTime && now - data.adFirstDisplayTime >= this.resetPeriodMs) {
            data.adDisplayCount = 0;
            data.adFirstDisplayTime = undefined;
        }
        const count = (_a = data.adDisplayCount) !== null && _a !== void 0 ? _a : 0;
        if (count >= this.maxDisplayCount) {
            return false;
        }
        if (!data.adFirstDisplayTime) {
            data.adFirstDisplayTime = now;
        }
        data.adDisplayCount = count + 1;
        this.writeConfig(data);
        return true;
    }
    static isNodeEnvironment() {
        var _a;
        return typeof process !== 'undefined' && ((_a = process.versions) === null || _a === void 0 ? void 0 : _a.node) !== undefined;
    }
    static getConfigPath() {
        if (!this.configPath) {
            const envPaths = Utils_1.Utils.nodeRequire('env-paths').default;
            const fs = Utils_1.Utils.nodeRequire('fs');
            const path = Utils_1.Utils.nodeRequire('path');
            const configDir = envPaths(this.projectName).config;
            fs.mkdirSync(configDir, { recursive: true });
            this.configPath = path.join(configDir, 'config.json');
        }
        return this.configPath;
    }
    static readConfig() {
        try {
            const fs = Utils_1.Utils.nodeRequire('fs');
            const raw = fs.readFileSync(this.getConfigPath(), 'utf8');
            return JSON.parse(raw);
        }
        catch (_a) {
            return {};
        }
    }
    static writeConfig(data) {
        try {
            const fs = Utils_1.Utils.nodeRequire('fs');
            fs.writeFileSync(this.getConfigPath(), JSON.stringify(data));
        }
        catch (_a) {
        }
    }
}
exports.AdvertisementUtils = AdvertisementUtils;
AdvertisementUtils.maxDisplayCount = 5;
AdvertisementUtils.resetPeriodMs = 3 * 24 * 60 * 60 * 1000;
AdvertisementUtils.ciEnvVars = [
    'CI',
    'CONTINUOUS_INTEGRATION',
    'GITHUB_ACTIONS',
    'GITLAB_CI',
    'TRAVIS',
    'CIRCLECI',
    'JENKINS_URL',
    'HUDSON_URL',
    'TEAMCITY_VERSION',
    'BUILDKITE',
    'TF_BUILD',
    'BITBUCKET_BUILD_NUMBER',
    'CODEBUILD_BUILD_ID',
    'DRONE',
    'HEROKU_TEST_RUN_ID',
    'NETLIFY',
    'VERCEL',
    'NOW_BUILDER',
    'RENDER',
    'CODESANDBOX_SSE',
    'STACKBLITZ'
];
AdvertisementUtils.projectName = 'javascript-obfuscator';
AdvertisementUtils.configPath = null;
